import { render, staticRenderFns } from "./MisCotizaciones.vue?vue&type=template&id=00856eba&scoped=true"
import script from "./MisCotizaciones.vue?vue&type=script&lang=js"
export * from "./MisCotizaciones.vue?vue&type=script&lang=js"
import style0 from "./MisCotizaciones.vue?vue&type=style&index=0&id=00856eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00856eba",
  null
  
)

export default component.exports